import { reduceToArray } from '../../../../utils/reduce-to-array';
import { getAreaCategoryById } from './get-area-category-by-id';
export const getAreaCategoriesByIds = (areaCategoryIds) => {
    return reduceToArray(areaCategoryIds, getAreaCategoryById);
};
//# sourceMappingURL=get-area-categories-by-ids.js.map